<style scoped>
    @import url("../../../styles/smartControl/periOffIrrig.scss");
</style>

<template>
    <div class="box_periOffIrrig">

        <div class="macro_el">
            <div class="tit ml-2">Período de suspensão de irrigação automática</div>

            <div class="painelBack mb-2 mt-2" v-if="!flagLiPoff">
                <v-chip color="#F5DDC0">Nenhum período de suspensão registrado</v-chip>
            </div>

            <div class="painelBack mb-2" v-if="liPoff.length > 0">

                <!-- @click="callFather(i)" -->
                <div class="painel" v-for="(el,i) in liPoff" :key="i"
                @mouseover="el.bg = '0px 1px 2px #f39c12'"
                @mouseleave="el.bg = ''"
                :style="{'box-shadow':el.bg}"
                >

                    <div class="card_el_info_icon">
                        <!--<v-icon>mdi-pencil-box-outline</v-icon>-->
                        <v-icon
                        :style="{'color':el.cor}"
                        >mdi-circle</v-icon>
                    </div>

                    <div class="card_el_info" 
                    :style="{'font-weight':'100'}"
                    >
                        <span class="">{{ el.status }}</span>
                    </div>

                    <div class="card_el_info"
                    :style="{'font-size':'1rem'}"
                    >
                        <span class="">{{ el.atuador }}</span>
                    </div>

                    <div v-if="el.status == 'Ligado'"
                    class="card_el_info"
                    :style="{'font-weight':'100'}"
                    >
                        <span class="">{{ el.hhmm_init }}</span>
                    </div>

                    <div v-if="el.status == 'Ligado'"
                    class="card_el_info"
                    :style="{'font-weight':'100'}"
                    >
                        <span class="">{{ el.hhmm_end }}</span>
                    </div>

                </div>

            </div>

        </div>

    </div>
</template>

<script>
import { convHhmmFromUtc } from "../auxSC/handleTimeConv.js"; // criado em 26/05/2026

export default {

    props:['agent_unit'],

    data() {
        return {

            // op
            liPoff:[],
            flagLiPoff:false,
        }
    },

    methods:{

        init() {

            //let liC = this.agent_unit['periodoOFF'] // lista de controladores contendo atuadores (pinos)
            
            // -- validar lista de processar.
            let liC = this.agent_unit?.periodoOFF

            if (!Array.isArray(liC) || liC.length === 0) {
                // lista inexistente ou vazia
                this.flagLiPoff = false
                return
            }
            
            let c=0
            while ( c < liC.length ) {

                // aux
                const init = liC[c]['utc_hhmm_init'] // string
                const end = liC[c]['utc_hhmm_end'] // string
                let resTimeInit = ""
                let resTimeEnd = ""
                if (init && end) {
                    const tzName = this.$store.state.fusoHorarioSC // esperado --> "Europe/Lisbon"
                    resTimeInit = convHhmmFromUtc(init, tzName)
                    resTimeEnd = convHhmmFromUtc(end, tzName)
                }

                let status = (liC[c]['status'] == 'on') ? 'Ligado' : 'Desligado'; // on/off
                let cor = (liC[c]['status'] == 'on') ? 'green' : ''; // on/off
                
                this.liPoff.push({
                    'status':status, // Ligado ou Desligado

                    'hhmm_init':resTimeInit, // string hhmm
                    'hhmm_end':resTimeEnd,

                    'atuador':liC[c]['actuator_name'],

                    'cor':cor,
                    'bg':''
                })

                c++
            }
            if (this.liPoff.length > 0) { this.flagLiPoff = true }
        },
    },

    created() {
        //window.scrollTo(0,0)
        this.init()
    }
}
</script>